/**
 * @deprecated This file is deprecated and will be removed in a future version.
 * Please import directly from '@/firebase/config' instead.
 * 
 * Examples:
 * import { db, auth, functions } from '@/firebase/config';
 */

import { db, auth, functions } from '@/firebase/config';

// Log a warning when this file is imported
console.warn(
  'Warning: Importing from "@/services/firebase" is deprecated and will be removed in a future version. ' +
  'Please update your imports to use "@/firebase/config" instead.'
);

export { db, auth, functions }; 